import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import updateDocument from "astrid-firestore/src/helpers/updateDocument";

import featureFlags from "../../../../authorization/constants/featureFlags";
import useHasRole from "../../../../authorization/hooks/useHasRole";
import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";
import useUserRoleOptions from "../../../../users/hooks/useUserRoleOptions";

export default function UserPermissions({ user }) {
	const { t } = useTranslation();

	const hasRole = useHasRole();

	const form = useSimpleForm({
		defaultValues: {
			role: user.permissions?.role || "user",
			featureFlags: user.featureFlags || [],
		},
		onSubmit: ({ role, featureFlags }) => {
			return updateDocument(user.ref, {
				featureFlags,
				"permissions.role": role,
			});
		},
	});

	const roleOptions = useUserRoleOptions();

	const { error, formState, onSubmit } = form;

	return (
		<>
			<Header as="h3">{t("permissions", "Permissions")}</Header>

			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Group widths="equal">
							<Form.Select
								name="role"
								label={t("role", "Role")}
								options={roleOptions.map((option) => ({
									...option,
									disabled: option.value === "owner",
								}))}
								disabled={user.permissions?.role === "owner"}
							/>
							<Form.Select
								name="featureFlags"
								label={t("featureFlags", "Feature flags")}
								options={[
									{
										key: featureFlags.FLATTENING,
										value: featureFlags.FLATTENING,
										text: t("flattening", "Flattening"),
									},
									{
										key: featureFlags.DISCUSSION,
										value: featureFlags.DISCUSSION,
										text: t("discussion", "Discussion"),
									},
								]}
								disabled={!hasRole("owner")}
								rules={{ required: false }}
								multiple
							/>
						</Form.Group>
					</Form>

					{error && <ErrorMessage error={error} />}
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
